import { OwcTypography } from '@one/react';
import { useTranslation } from 'core/i18n';
import React, { PropsWithChildren } from 'react';
import { useScreenSizeGuard } from './screen-size-guard.hook';
import { ScreenSizeGuardLayout } from './screen-size-guard.style';

export const AppScreenSizeGuard: React.FC<PropsWithChildren> = ({ children }) => {
  const { t } = useTranslation('common');
  const isTooSmallScreen = useScreenSizeGuard();

  return isTooSmallScreen ? (
    <ScreenSizeGuardLayout>
      <OwcTypography variant="title4">{t('components.size-guard.title')}</OwcTypography>
      <OwcTypography variant="subtitle1">{t('components.size-guard.subtitle')}</OwcTypography>
    </ScreenSizeGuardLayout>
  ) : (
    <>{children}</>
  );
};
